import React from 'react';

import type { ViralTemplateTypeTab } from '../../../hooks/useViralTemplateRouteState';
import { ViralTemplateCategory } from '../../../hooks/useViralTemplateRouteState';
import {
  // MetaTopAdsPreviewSection,
  UgcPreviewSection,
} from './sections';

const OverviewPage = ({
  onGoToCategory,
}: {
  onGoToCategory: (
    category: ViralTemplateCategory,
    subtab?: ViralTemplateTypeTab,
  ) => void;
}) => {
  return (
    <div className="flex h-full min-h-0 flex-col gap-[24px] overflow-y-auto no-scrollbar">
      <UgcPreviewSection
        onViewMore={(subtab) => onGoToCategory(ViralTemplateCategory.UGC, subtab)}
      />
      {/* <MetaTopAdsPreviewSection
        onViewMore={() => onGoToCategory(ViralTemplateCategory.META_TOP_ADS)}
      /> */}
    </div>
  );
};

export default OverviewPage;
